import moment from "moment";
import { useEffect, useState } from "react";
import { CHART_OPTIONS, DROPDOWN_FIELDS, getParamDropDownOptions } from "../../../common/constant/common-constants";
import { CHART_CONST } from "../../../common/constant/page-constants";
import "./ChartTable.scss";

export function ChartTable(props) {
    const [headerList, setHeaderList] = useState(props.headerList);
    const [parameterList, setParameterList] = useState(props.parameterList);
    const [showDropDown, setShowDropDown] = useState("");
    const [data, setData] = useState("");

    useEffect(() => {
        setHeaderList([...props.headerList]);
        setParameterList([...props.parameterList]);
        setData({ ...props.data });
    }, [props]);

    const handleChange = (type, id, key, event) => {
        // console.log("type", type, "id", id, "key", key, "event", event.target.value)
        let header = id;
        if (headerList.indexOf(id) > -1) {
            header = id;
            id = CHART_CONST.NEW_ID_PRED + id;
        }
        let value = event && event.target && event.target.value;

        if (value === "on") value = event.target.checked;

        if (value === undefined) return;
        props.handleDataChange(id, header, key, value);
    }

    const handleInputType = (e, param) => {
        if (param.type === "number")
            return e.target.value = e.target.value.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1').replace(/^0[^.]/, '0');
        else if (param.type === "drop-down") return e.target.value = ""
        else return
    }

    const handleParamModalClick = (event, header, name, height) => {
        // event.stopPropagation();
        if (!props.isEditable) return;
        if (!showDropDown) {
            event.stopPropagation();
            setShowDropDown(`${header} ${name}`);
            let ele = document.getElementsByClassName('drop-down-container');


            window.addEventListener('click', function (e) {
                if (ele && e.target === ele[0]) {
                    console.log("inside click");
                } else {
                    console.log("outside click");
                    setShowDropDown("")
                }
            })
        }
    }
    const handleDropDownSelect = (id, key, value) => {
        // console.log("id", id, "key", key, "event", value);
        let header = id;
        if (headerList.indexOf(id) > -1) {
            header = id;
            id = CHART_CONST.NEW_ID_PRED + id;
            console.log(id);
        }

        if (value === undefined) return;
        props.handleDataChange(id, header, key, value);
    }

    const getHtml = () => {

        let html = headerList && headerList.map((header, count) => {
            let headerTime = moment(header, "HH:mm");
            let currentTime = moment(new Date(), "HH:mm");
            let borderTime = moment("08:00", "HH:mm");

            /* for rendering parameters in first column */
            if (count === 0) {
                return (
                    <div className="column parameters" key={header}>
                        <div className="cell heading param">{header}</div>
                        {parameterList.map((param) => {
                            return (<div className="cell body param" key={param.label}>{param.label}</div>)
                        })}
                    </div>);

            } else {
                let selectedDate = props.data.date;
                let currDate = moment(new Date()).format("YYYY-MM-DD")
                // if the current date is same as selected date all will go defined below.
                if (moment(selectedDate).isSame(currDate)) {

                    /** rendering data from the data array **/
                    let col = data && data.data &&
                        data.data.filter((obj) => moment(obj.time, "HH:mm").isSame(headerTime))[0];

                    if (col) {
                        return (
                            <div className="column" key={header}>
                                <div className="cell heading">{header}</div>
                                {parameterList.map((param, colCount) => {
                                    return (
                                        <div className="cell body" key={param.name}>
                                            {(col["isUpdated"] || !props.isEditable) ?
                                                col[param.name]
                                                : <input
                                                    className="chart-input"
                                                    value={col[param.name] || ""}
                                                    readOnly={col["isUpdated"] || !props.isEditable}
                                                    onChange={(event) => handleChange(CHART_CONST.UPDATE, col["id"], param.name, event)}
                                                    onInput={(event) => handleInputType(event, param)}
                                                    onClick={(event) => handleParamModalClick(event, header, param.name, param.height)}
                                                />
                                            }
                                            {showDropDown === `${header} ${param.name}` &&

                                                param.options && <div className={colCount < 5 ? "drop-down-container" : "drop-down-container drop-up"} style={{ height: param.height }} >
                                                    {param.options.map((option) => {
                                                        // console.log("option.label", option.label, "param.name", col[param.name]);
                                                        return (
                                                            <div className={option.name === col[param.name] ? "drop-down-option selected" : "drop-down-option"}
                                                                onClick={() => {
                                                                    handleDropDownSelect(col["id"], param.name, option.name)
                                                                    setShowDropDown("")
                                                                }}
                                                                key={option.id}
                                                            >
                                                                {option.label}
                                                            </div>)
                                                    })}
                                                </div>
                                            }

                                        </div>);
                                })
                                }
                            </div >);
                    }

                    /** if current time is after border time, 
                     *  then all fields before that time should be input type 
                     * 
                     *  if current time is before border time
                     * */
                    if (currentTime.isAfter(borderTime)) {
                        if (headerTime.isBefore(currentTime) && !headerTime.isBefore(borderTime)) {
                            return (<div className="column" key={header}>
                                <div className="cell heading">{header}</div>
                                {
                                    parameterList.map((param, colCount) => {
                                        return (
                                            <div className="cell body" key={param.name}>
                                                <input
                                                    className="chart-input"
                                                    readOnly={!props.isEditable}
                                                    onChange={(event) => handleChange(CHART_CONST.ADD, header, param.name, event)}
                                                    onInput={(e) => handleInputType(e, param)}
                                                    onClick={(event) => handleParamModalClick(event, header, param.name, param.height)}
                                                />

                                                {showDropDown === `${header} ${param.name}` &&
                                                    param.options && <div className={colCount < 5 ? "drop-down-container" : "drop-down-container drop-up"} style={{ height: param.height }} >
                                                        {param.options.map((option) => {
                                                            // console.log("name", param)
                                                            return (<div className="drop-down-option"
                                                                onClick={() => {
                                                                    handleDropDownSelect(header, param.name, option.name)
                                                                    setShowDropDown("")
                                                                }}
                                                                key={option.id}
                                                            >
                                                                {option.label}
                                                            </div>)
                                                        })}
                                                    </div>
                                                }
                                            </div>);
                                    })
                                }
                            </div >);
                        }
                    } /** if current time is before borderTime, block all between currentTime and borderTime */
                    else if (currentTime.isBefore(borderTime)) {
                        if (headerTime.isBefore(currentTime) ||
                            (headerTime.isAfter(currentTime) && !headerTime.isBefore(borderTime))) {
                            return (<div className="column" key={header}>
                                <div className="cell heading">{header}</div>
                                {
                                    parameterList.map((param, colCount) => {
                                        return (<div className="cell body" key={param.name}>
                                            <input
                                                className="chart-input"
                                                readOnly={!props.isEditable}
                                                onChange={(event) => handleChange(CHART_CONST.ADD, header, param.name, event)}
                                                onInput={(e) => handleInputType(e, param)}
                                                onClick={(event) => handleParamModalClick(event, param)}
                                            />
                                        </div>);
                                    })
                                }
                            </div >);
                        }
                    }
                    /** empty column for which data is not present as of now */

                    return (<div className="column" key={header}>
                        <div className="cell heading">{header}</div>
                        {
                            parameterList.map((param, colCount) => {
                                return <div className="cell body not-allowed" key={colCount}></div>
                            })
                        }
                    </div >);
                } else if (moment(selectedDate).isBefore(currDate)) { // if the selected date isBefore the currDate, then all columns should be editable
                    let col = data && data.data &&
                        data.data.filter((obj) => moment(obj.time, "HH:mm").isSame(headerTime))[0];

                    if (col) {
                        return (
                            <div className="column" key={header}>
                                <div className="cell heading">{header}</div>
                                {parameterList.map((param, colCount) => {
                                    return (
                                        <div className="cell body" key={param.name}>
                                            {(col["isUpdated"] || !props.isEditable) ?
                                                col[param.name]
                                                : <input
                                                    className="chart-input"
                                                    value={col[param.name] || ""}
                                                    readOnly={col["isUpdated"] || !props.isEditable}
                                                    onChange={(event) => handleChange(CHART_CONST.UPDATE, col["id"], param.name, event)}
                                                    onInput={(event) => handleInputType(event, param)}
                                                    onClick={(event) => handleParamModalClick(event, header, param.name, param.height)}
                                                />
                                            }
                                            {showDropDown === `${header} ${param.name}` &&
                                                param.options && <div className={colCount < 5 ? "drop-down-container" : "drop-down-container drop-up"} >
                                                    {param.options.map((option) => {
                                                        // console.log("option.label", option.label, "param.name", col[param.name]);
                                                        return (
                                                            <div className={option.name === col[param.name] ? "drop-down-option selected" : "drop-down-option"}
                                                                onClick={() => {
                                                                    handleDropDownSelect(col["id"], param.name, option.name)
                                                                    setShowDropDown("")
                                                                }}
                                                                key={option.id}
                                                            >
                                                                {option.label}
                                                            </div>)
                                                    })}
                                                </div>
                                            }

                                        </div>);
                                })
                                }
                            </div >);
                    } else {
                        return (<div className="column" key={header}>
                            <div className="cell heading">{header}</div>
                            {
                                parameterList.map((param, colCount) => {
                                    return (
                                        <div className="cell body" key={param.name}>
                                            <input
                                                className="chart-input"
                                                readOnly={!props.isEditable}
                                                onChange={(event) => handleChange(CHART_CONST.ADD, header, param.name, event)}
                                                onInput={(e) => handleInputType(e, param)}
                                                onClick={(event) => handleParamModalClick(event, header, param.name, param.height)}
                                            />

                                            {showDropDown === `${header} ${param.name}` &&
                                                param.options && <div className={colCount < 5 ? "drop-down-container" : "drop-down-container drop-up"} style={{ height: param.height }} >
                                                    {param.options.map((option) => {
                                                        // console.log("name", param)
                                                        return (<div className="drop-down-option"
                                                            onClick={() => {
                                                                handleDropDownSelect(header, param.name, option.name)
                                                                setShowDropDown("")
                                                            }}
                                                            key={option.id}
                                                        >
                                                            {option.label}
                                                        </div>)
                                                    })}
                                                </div>
                                            }
                                        </div>);
                                })
                            }
                        </div >);
                    }
                } else {
                    // the selected date is of future so all should be disabled
                    return (<div className="column" key={header}>
                        <div className="cell heading">{header}</div>
                        {
                            parameterList.map((param, colCount) => {
                                return <div className="cell body not-allowed" key={colCount}></div>
                            })
                        }
                    </div >);
                }


            }
        });

        return html;
    }

    const getNursingCheckHtml = () => {
        let html = headerList && headerList.map((header, count) => {

            /* for rendering parameters in first column */
            if (count === 0) {
                return (
                    <div className="column parameters" key={count}>
                        <div className="cell heading param-nursing">{header}</div>
                        {parameterList.map((param) => {
                            return (<div className="cell body param-nursing" key={param.label}>{param.label}</div>)
                        })}
                    </div>);
            } else {
                /** rendering data from the data array **/
                let col = data && data.data && data.data[count - 1] &&
                    data.data.filter((obj) => obj.shift === header)[0];

                // console.log("col inside", col);

                if (col) {
                    return (<div className="column" key={count}>
                        <div className="cell heading">{header}</div>
                        {parameterList.map((param) => {
                            if (param.type === "text") { return <div className="cell body" key={param.name}>{col[param.name]}</div> }
                            else if (param.type === "checkbox") {
                                return (
                                    <div className="cell body" key={param.name}>
                                        <input
                                            className={col["isUpdated"] || !props.isEditable ? "chart-checkbox disabled" : "chart-checkbox"}
                                            checked={col[param.name]}
                                            type="checkbox"
                                            aria-disabled={col["isUpdated"] || !props.isEditable}
                                            onChange={(event) => handleChange(CHART_CONST.UPDATE, col["id"], param.name, event)} />
                                    </div>);
                            }
                            else if (param.type === "double-checkbox") {
                                return (
                                    <div className="cell body double-checkbox-container" key={param.name}>
                                        <div className="first-checkbox double-checkbox-item">
                                            <input
                                                className="chart-radio"
                                                checked={col[param.name] === "PRESENT"}
                                                id={`col - present - ${param.name}${header} `}
                                                name={`${header} -${param.name} `}
                                                type="radio"
                                                value={'PRESENT'}
                                                aria-disabled={col["isUpdated"] || !props.isEditable}
                                                onChange={(event) => {
                                                    event.target.value = event.target.checked ? "PRESENT" : "ABSENT";
                                                    handleChange(CHART_CONST.UPDATE, col["id"], param.name, event)
                                                }} />
                                            <label htmlFor={`col - present - ${param.name}${header} `} className="label">Present</label>
                                        </div>
                                        <div className="second-checkbox double-checkbox-item">
                                            <input
                                                className="chart-radio"
                                                checked={col[param.name] === "ABSENT"}
                                                id={`col - absent - ${param.name}${header} `}
                                                name={`${header} -${param.name} `}
                                                type="radio"
                                                value={'ABSENT'}
                                                aria-disabled={col["isUpdated"] || !props.isEditable}
                                                onChange={(event) => {
                                                    event.target.value = event.target.checked ? "ABSENT" : "PRESENT";
                                                    handleChange(CHART_CONST.UPDATE, col["id"], param.name, event)
                                                }} />
                                            <label htmlFor={`col - absent - ${param.name}${header} `} className="label">Absent</label>
                                        </div>
                                    </div>);
                            }
                        })}
                    </div>);
                } else {
                    return (<div className="column" key={count}>
                        <div className="cell heading">{header}</div>
                        {
                            parameterList.map((param, count) => {
                                if (param.type === "text") { return <div className="cell body" key={count}></div> }
                                else if (param.type === "checkbox") {
                                    return (<div className="cell body" key={param.name} >
                                        <input
                                            type="checkbox"
                                            className="chart-checkbox"
                                            aria-disabled={!props.isEditable ? true : false}
                                            onChange={(event) => handleChange(CHART_CONST.ADD, header, param.name, event)} />
                                    </div>);
                                }
                                else if (param.type === "double-checkbox") {
                                    return (
                                        <div className="cell body double-checkbox-container" key={param.name}>
                                            <div className="first-checkbox  double-checkbox-item">
                                                <input
                                                    className="chart-radio"
                                                    name={`${header} -${param.name} `}
                                                    id={`present - ${param.name}${header} `}
                                                    type="radio"
                                                    aria-disabled={!props.isEditable}
                                                    onChange={(event) => {
                                                        event.target.value = event.target.checked ? "PRESENT" : "ABSENT";
                                                        handleChange(CHART_CONST.ADD, header, param.name, event)
                                                    }} />
                                                <label htmlFor={`present - ${param.name}${header} `} className="label">Present</label>
                                            </div>
                                            <div className="second-checkbox  double-checkbox-item">
                                                <input
                                                    className="chart-radio"
                                                    id={`absent - ${param.name}${header} `}
                                                    name={`${header} -${param.name} `}
                                                    type="radio"
                                                    aria-disabled={!props.isEditable}
                                                    onChange={(event) => {
                                                        event.target.value = event.target.checked ? "ABSENT" : "PRESENT";
                                                        handleChange(CHART_CONST.ADD, header, param.name, event)
                                                    }} />
                                                <label htmlFor={`absent - ${param.name}${header} `} className="label">Absent</label>
                                            </div>
                                        </div>);
                                }
                            })
                        }
                    </div >);
                }
            }

        });

        return html;
    }

    return <>
        <div className="table">

            {
                (props.chartType === CHART_OPTIONS.NURSING_CHECKS) ?
                    getNursingCheckHtml() : getHtml()
            }
        </div>
    </>
}